import * as LeadTextTypes from '../types'
import * as Constants from './constants'
import * as Types from './types'

export const asFormFields = (lt: LeadTextTypes.LeadText): Types.FormFields => {
  return {
    community_partner_code: lt.community_partner_code,
    description: lt.description,
    editor_state: lt.editor_state,
    end_date: lt.end_datetime,
    id: lt.id,
    is_active: lt.is_active,
    start_date: lt.start_datetime,
    styles: lt.styles,
    title: lt.title,
  }
}

export const transformIfRaw = (payloadData: any): any => {
  return (payloadData.type === Constants.RAW_EDITOR) ?
    {
      ...payloadData,
      editor_state: null,
      styles: null,
    }
  : payloadData
}



// WEBPACK FOOTER //
// ./src/pages/lead-text/add-edit-modal/utils.ts